import { FormatNumberOptions as ReactIntlFormatNumberOptions } from 'react-intl';

import { FormatNumberOptions } from '~/eds/src/types/FormatNumberOptions';

import { isBrowserSupportedUnit } from '../../utils';
import { useFormattingIntl } from '../useFormattingIntl/useFormattingIntl';

//import { useCurrency } from '~/common/contexts/I18nProvider';

export const useFormatNumber = () => {
  //TODO: once we have a BE unified currency conversion, we can use the currency prop by adding it to CurrencyContext.Provider
  //const { currency } = useCurrency();
  const overrideIntlLocale = useFormattingIntl();

  return (
    number: number | bigint | null | undefined,
    options?: FormatNumberOptions,
  ) => {
    if (number == null || !Number.isFinite(Number(number))) return '—';

    /** If the unit is not a standard unit, we need to format it before this hook with i18n
     * e.g. For "1 document" to be "1 documents" vs "0 documents" we need to go to the passing component
     */

    if (options?.unit && !isBrowserSupportedUnit(options.unit)) {
      const numberFormatOptions: ReactIntlFormatNumberOptions = {
        style: 'decimal',
        maximumFractionDigits: options?.decimal,
        minimumFractionDigits: options?.includeTrailingZeros
          ? options?.decimal
          : undefined,
        ...(options?.precision && {
          minimumSignificantDigits: options?.precision,
          maximumSignificantDigits: options?.precision,
        }),
      };

      return `${overrideIntlLocale.formatNumber(number, numberFormatOptions)} ${
        options?.unit
      }`;
    }

    // Map EDS options to React-Intl options
    const reactIntlOptions: ReactIntlFormatNumberOptions = {
      style: options?.style as 'decimal' | 'currency' | 'unit' | 'percent',
      minimumFractionDigits: options?.includeTrailingZeros
        ? options?.decimal
        : undefined,
      maximumFractionDigits: options?.decimal,
      currencySign: 'accounting',

      ...(options?.precision && {
        minimumSignificantDigits: options.precision,
        maximumSignificantDigits: options.precision,
      }),

      ...(options?.currency && {
        style: 'currency',
        currency: options?.currency,
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }),

      ...(options?.unit && {
        style: 'unit',
        unit: options?.unit,
        unitDisplay: 'long',
      }),
    };

    return overrideIntlLocale.formatNumber(number, reactIntlOptions);
  };
};
